import { Quote, Star } from "lucide-react";
import Reveal from "../Reveal";

const reviews = [
  {
    quote:
      "Het adviesgesprek was vrijblijvend maar zo waardevol — ze dachten écht mee. Onze inloopdouche is precies zoals we hem voor ons zagen, alleen mooier.",
    name: "Familie van der Berg",
    place: "Amsterdam",
  },
  {
    quote:
      "Voor onze kantoorpand renovatie van vier toiletruimtes hadden we een strakke planning nodig. MasterBathrooms leverde op tijd en netjes op.",
    name: "Mark — Office Manager",
    place: "Haarlem",
  },
  {
    quote:
      "Strak vakwerk, eerlijke prijs en schoon werken. Eén aanspreekpunt voor het hele project — dat heeft het zo makkelijk gemaakt.",
    name: "Sanne & Tim",
    place: "Utrecht",
  },
];

export default function Reviews() {
  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative py-24 md:py-32 bg-white overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <div className="max-w-3xl">
            <span className="tag-overline">04 — Reviews</span>
            <h2 className="mt-4 text-5xl md:text-6xl text-[#0A0A0A] leading-[1.02] uppercase tracking-tight">
              Klanten over
              <br />
              <span className="text-[#1E5BC6]">hun ervaring.</span>
            </h2>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <Reveal key={i} delay={i * 100}>
              <figure
                data-testid={`review-card-${i}`}
                className="bg-[#F5F7FB] border border-[#E5E7EB] p-8 md:p-10 h-full flex flex-col hover:border-[#1E5BC6]/40 transition-colors"
              >
                <Quote className="text-[#1E5BC6]" size={28} strokeWidth={1.6} />
                <div className="mt-4 flex gap-1">
                  {Array.from({ length: 5 }).map((_, idx) => (
                    <Star
                      key={idx}
                      size={14}
                      className="text-[#1E5BC6] fill-[#1E5BC6]"
                    />
                  ))}
                </div>
                <blockquote className="mt-5 text-lg leading-snug text-[#0A0A0A] flex-1 font-medium">
                  “{r.quote}”
                </blockquote>
                <figcaption className="mt-7 pt-5 border-t border-[#E5E7EB]">
                  <div className="text-sm font-bold text-[#0A0A0A] uppercase tracking-wide">
                    {r.name}
                  </div>
                  <div className="text-[10px] uppercase tracking-[0.22em] text-[#5A5A5A] mt-1 font-semibold">
                    {r.place}
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
